/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */

export type ListTrajectoriesApiTrajectoriesGetRange =
  (typeof ListTrajectoriesApiTrajectoriesGetRange)[keyof typeof ListTrajectoriesApiTrajectoriesGetRange];

export const ListTrajectoriesApiTrajectoriesGetRange = {
  "1h": "1h",
  "24h": "24h",
  "48h": "48h",
  "5d": "5d",
  "7d": "7d",
  "14d": "14d",
  "30d": "30d",
  all: "all",
} as const;
